import React, { Component } from 'react';
import Slider from 'react-slick';

export default class PhotoAlbum extends Component {
  render() {
    const { items, contentKey } = this.props;
    const settings = {
      //adaptiveHeight: true,
      dots: true,
      infinite: false,
			arrows: false,
			swipe: true,
      speed: 500
    };
    return (
      <Slider {...settings}>
        { items.map( (item, index) => (<img key={`${contentKey}-photo-${index}`} alt="" src={`${item.url}`} />) ) }
      </Slider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PhotoAlbum.js